<section class="site-milestones-main-wrap">
    <div class="container">
        <div class="site-milestones-main">
            <div class="site-milestones-content-play-store">
                <div class="site-milestones-play-store-content">
                    <h2 class="site-heading-h2">Download from Google Play</h2>
                </div>
                <div class="site-milestone-next-arrow">
                    <img src="images/svg/next-arrow.svg" alt="Next Arrow Icon">
                </div>
                <div class="site-milestone-play-store-img">
                    <a href="https://play.google.com/store/apps/details?id=social.network.finder" target="_blank"><img
                            src="images/svg/google-play-store.svg" alt="Google Play Store Icon"></a>
                </div>
            </div>
        </div>
    </div>
</section>